import { Linkedin, Mail } from "lucide-react";

const NAV_COLS = [
  {
    title: "Services",
    links: [
      ["Profit audit", "#audit"],
      ["Revenue management", "#services"],
      ["Operational efficiency", "#services"],
      ["Retainer", "#services"],
    ],
  },
  {
    title: "Practice",
    links: [
      ["About", "#about"],
      ["Approach", "#approach"],
      ["FAQ", "#faq"],
      ["Contact", "#contact"],
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="/logo.png"
                alt="Black Rock Hospitality"
                className="h-16 md:h-20 w-auto"
              />
            </div>
            <p className="text-white/55 leading-relaxed max-w-md">
              Accommodation revenue & operations consulting for motels, hotels,
              hostels, Airbnb operators, investment property owners, holiday
              home managers and boutique stays.
            </p>

            <div className="mt-8 flex items-center gap-4">
              <a
                href="mailto:aaron@blackrockhospitality.co.nz"
                data-testid="footer-email"
                aria-label="Email"
                className="w-10 h-10 border border-white/15 hover:border-[#C2A878] hover:text-[#C2A878] flex items-center justify-center transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="w-10 h-10 border border-white/15 hover:border-[#C2A878] hover:text-[#C2A878] flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {NAV_COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#C2A878] font-semibold mb-6">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-white/65 hover:text-[#C2A878] transition-colors"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#C2A878] font-semibold mb-6">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-white/65">
              <li>Bay of Plenty, NZ</li>
              <li>
                <a
                  href="tel:+64275188521"
                  data-testid="footer-phone-text"
                  className="hover:text-[#C2A878] transition-colors"
                >
                  +64 27 518 8521
                </a>
              </li>
              <li>
                <a
                  href="mailto:aaron@blackrockhospitality.co.nz"
                  data-testid="footer-email-text"
                  className="hover:text-[#C2A878] transition-colors"
                >
                  aaron@blackrockhospitality.co.nz
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Oversized brand wordmark */}
        <div className="py-16 select-none">
          <div className="font-serif text-[18vw] md:text-[14vw] leading-none text-white/[0.04] tracking-tight">
            Black&nbsp;Rock.
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-6 border-t border-white/10">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} Black Rock Hospitality. All rights reserved.
          </div>
          <div className="text-xs text-white/40 tracking-[0.2em] uppercase">
            Crafted in the Bay of Plenty
          </div>
        </div>
      </div>
    </footer>
  );
}
